<script setup lang="ts">
import { Ref, ref, useSlots } from "vue";
defineProps<{
  title?: string, 
  toggle?: () => void,
  state?: Ref<boolean>,
  className?: string
}>();

const slots = useSlots()
const custom = ref(!!slots.default)
</script>

<template>
  <div
    class="trigger" :class="state?.value? className + ' trigger-active': className + ''" 
    @click="toggle"
  >
    <div v-if="!custom" class="trigger__content">
      <h4>{{title}}</h4>
      <img 
        src="/assets/icons/arrow-down.svg" 
        alt="arrow" :class="state?.value? 'rotate' : ''"
      >
    </div>
    <slot v-else />
  </div>
</template>

<style scoped lang="scss">

.trigger {
  display: block;
  cursor: pointer;
  padding: 40px;
  border-radius: 32px;
  transition: all 0.3s;

  @media screen and (max-width: 800px) {
    padding: 20px;
    border-radius: 24px;
  }


  &__content {
    display: flex;
    justify-content: space-between;
    font-size: var(--font-size-m);

    h4 {
      margin: 0;
      display: flex;
      align-items: center;
      color: var(--color-mono-900);
      font-size: var(--font-size-md);
    }

    img {
      margin-left: 16px;
      transition: all 0.3s;
      transform: rotate(0deg);
    }

    .rotate {
      transform: rotate(180deg);
    }
  }
}

.trigger-active {
  padding-bottom: 0;
}

summary {
  list-style: none;
}

summary::-webkit-details-marker {
  display: none;
}
</style>